import React from "react";

export function ReferenceSkeleton() {
  return (
    <div
      className="sw-docs-reference sw-docs-reference-skeleton ph-no-capture ph-no-record"
      role="status"
      aria-label="Loading the verified API reference"
      aria-busy="true"
    >
      <p>Loading the verified API reference…</p>
      <div aria-hidden="true" className="sw-docs-skeleton-content">
        <div className="sw-docs-skeleton-title" />
        <div className="sw-docs-skeleton-line" />
        <div className="sw-docs-skeleton-line sw-docs-skeleton-short" />
        <div className="sw-docs-skeleton-columns">
          <div>
            <div className="sw-docs-skeleton-title" />
            <div className="sw-docs-skeleton-panel" />
          </div>
          <div className="sw-docs-skeleton-panel" />
        </div>
      </div>
    </div>
  );
}
